import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const ExitIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M4.6 37.4V10.6h16.9v5h-1.4V12H6v24h14.1v-3.6h1.4v5H4.6Zm29.05-7.7-1-1 4.1-4h-24.8v-1.4h24.8l-4.1-4 1-1 5.8 5.7-5.8 5.7Z"
            />
        </svg>
    </IconWrapper>
));
